import React, { PureComponent } from 'react';
import Avatar from 'react-avatar';
import { Text, Theme, CardBlock } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';
import { constants } from '@simplybenefits/sb-utils';

const StyledCardBlockLeft = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    verticalAlign: 'middle',
    width: '70%',
    [theme.breakpoints.down('500')]: {
        width: 'unset'
    }
}));

const StyledCardBlockRight = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '10px 15px 10px 10px',
    width: '30%',
    [theme.breakpoints.down('500')]: {
        width: '100%'
    }
}));

class UserCard extends PureComponent {
    render() {
        const { user, testid, id } = this.props;
        const name = `${ user.firstname } ${ user.lastname }`;
        const status = constants.memberStatusMap[user.status];
        const styles = {
            cardBlockMain: {
                display: 'flex',
                width: '100%',
                // [theme.breakpoints.down('500')]: {
                //     flexWrap: 'wrap'
                // },
                marginBottom: '5px',
                padding: 0,
                minHeight: '60px',
                height: 'auto'
            },
            cardBlockAvatar: {
                padding: '20px 20px 20px 15px'
            },
            cardBlockLeftBody: {
                display: 'inline',
                lineHeight: 1.2
            }
        };

        return (
            <CardBlock
                id={id || testid}
                style={ styles.cardBlockMain }
                onClick={this.props.onClick || null}
            >
                <StyledCardBlockLeft>
                    <div style={styles.cardBlockAvatar}>
                        <Avatar
                            name={name}
                            size="40"
                            textSizeRatio={2.2}
                            round={true}
                            fgColor={Theme.colors.skyBlue}
                            color={Theme.colors.lightBlue}
                        />
                    </div>

                    <div style={styles.cardBlockLeftBody}>
                        <Text mediumLarge display="block">
                            {name}
                        </Text>

                        <Text small display="block">
                            {user.email}
                        </Text>
                    </div>
                </StyledCardBlockLeft>

                <StyledCardBlockRight>
                    <Text
                        color={ status === 'Active' ? Theme.colors.brandGreen : status === 'Account Disabled' ? Theme.colors.red : Theme.colors.darkGrey }
                        align="right"
                        mediumLarge
                        display="block"
                    >
                        { status }
                    </Text>
                </StyledCardBlockRight>
            </CardBlock>
        );
    }
}

export default (UserCard);